import {useGetProductTemplateConfig} from "api/api-hooks/product-templates-hooks";
import {MultiSelect, MultiSelectChangeParams} from "primereact/multiselect";
import React, {useEffect, useState} from "react";
import {IProductTemplateDropdownChangeParams} from "../product-template/ProductTemplateDropdown";

interface IHiddenColumnsDropdownProps {
    value?: Array<string>;
    onChange?: (e: MultiSelectChangeParams) => void;
    selectedTemplate?: IProductTemplateDropdownChangeParams;
    className?: string;
    id?: string;
    disabled?: boolean;
}

export default function ProductTemplateColumnsDropdown(props: IHiddenColumnsDropdownProps) {
    const [allSelections, setAllSelections] = useState<object[]>([]);

    const query = useGetProductTemplateConfig(props.selectedTemplate?.refName!, `${  props.selectedTemplate?.value}`);

    useEffect(() => {
        if (query.data) {
            const selections = query.data.data?.attributes.map((element: any) => ({
                label: element.displayName,
                value: element.referenceName,
            }));

            setAllSelections(selections ?? []);
        }
    }, [query.data]);

    const onChange = (e: MultiSelectChangeParams) => {
        props.onChange?.(e);
    };

    return (
        <>
            {query.error && <span>Product template selection error!</span>}

            {query.isLoading && !query.error && <span>Product templates loading...</span>}

            {query.isSuccess &&
                <MultiSelect placeholder="Select Columns" id={props.id} className={props.className} value={props.value || null} options={allSelections}
                             onChange={onChange} showClear disabled={props.disabled} maxSelectedLabels={1}/>}
        </>
    );
}
